<script lang="ts">
  import type { ChoiceSummary } from '../../types';
  import { colorVar, initials } from '../../lib/race';
  let { choice, size = 44 }: { choice: Pick<ChoiceSummary, 'name' | 'color'>; size?: number } = $props();
  const c = $derived(colorVar(choice as ChoiceSummary));
</script>

<span class="av" style="--c:{c};--s:{size}px" aria-hidden="true">{initials(choice.name)}</span>

<style>
  .av {
    flex: none; width: var(--s); height: var(--s); border-radius: 50%; display: inline-grid; place-items: center;
    font: 700 calc(var(--s) * 0.36) / 1 var(--display); letter-spacing: 0.01em; color: var(--c);
    background: color-mix(in oklab, var(--c) 12%, var(--card));
    box-shadow: inset 0 0 0 2.5px var(--c), 0 0 0 3px var(--card);
  }
</style>
